var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_95259)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1882 18.9616L26.7002 15.4913L23.376 13.938L26.7002 12.3516L28.1882 8.91431L29.7079 12.3516L33.0004 13.938L29.7079 15.4913L28.1882 18.9616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0633 14.3938L14.1164 12.1854L12.001 11.1969L14.1164 10.1873L15.0633 8L16.0304 10.1873L18.1256 11.1969L16.0304 12.1854L15.0633 14.3938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1783 21.312L24.1651 24.3162C24.5032 24.6563 24.8936 24.8221 25.3362 24.8135C25.7788 24.8049 26.163 24.6241 26.4888 24.2711C26.8146 23.9181 26.9734 23.5106 26.9652 23.0485C26.9569 22.5865 26.7837 22.1854 26.4456 21.8453L20.5846 15.9502C20.2465 15.6101 19.8561 15.4444 19.4135 15.453C18.9709 15.4616 18.5867 15.6424 18.2609 15.9954L12.614 22.1138C12.2882 22.4668 12.1294 22.8743 12.1377 23.3364C12.1459 23.7985 12.3191 24.1995 12.6572 24.5396C12.9953 24.8797 13.3857 25.0455 13.8283 25.0369C14.2709 25.0283 14.6551 24.8475 14.9809 24.4945L17.8587 21.3765L18.0151 30.1556C18.024 30.6561 18.1881 31.067 18.5075 31.3882C18.8268 31.7094 19.2262 31.8654 19.7057 31.8561C20.1852 31.8468 20.5788 31.6754 20.8865 31.342C21.1942 31.0087 21.3436 30.5917 21.3347 30.0911L21.1783 21.312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_95259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterDisabled);
export default __webpack_public_path__ + "static/media/EnterDisabled.f86e22faa2c54be53b191343c2d7d5b1.svg";
export { ForwardRef as ReactComponent };